import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.storageKey = `category-sort-scroll:${location.pathname}`;
    try {
      const stored = sessionStorage.getItem(this.storageKey);
      if (!stored) return;
      sessionStorage.removeItem(this.storageKey);
      const state = JSON.parse(stored);
      if (state.url !== location.href || Date.now() - state.time > 60000 || !Number.isFinite(state.y)) return;
      this.restoreScroll = () => window.scrollTo({top: state.y, left: 0, behavior: 'instant'});
      this.scrollFrame = requestAnimationFrame(this.restoreScroll);
      window.addEventListener('load', this.restoreScroll, {once: true});
    } catch (_) { /* Sorting also works when browser storage is unavailable. */ }
  }

  disconnect() {
    cancelAnimationFrame(this.scrollFrame);
    if (this.restoreScroll) window.removeEventListener('load', this.restoreScroll);
  }

  remember() {
    const target = new URL(this.element.action);
    target.search = new URLSearchParams(new FormData(this.element)).toString();
    target.hash = '';
    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify({url: target.href, y: window.scrollY, time: Date.now()}));
    } catch (_) { /* Submit normally when browser storage is unavailable. */ }
  }

  change() {
    this.element.requestSubmit();
  }
}
